import { useEffect, useState } from "react";
import { findMatches, savedAi, streamAi } from "../../lib/searchApi";

const ORDER = { sku: 0, branch: 1, supplier: 2 };
const IDLE = { status: "idle", meta: null, text: "", done: null, error: null };

// Debounced SKU / branch / supplier matches for the top-bar dropdown.
export function useMatches(q, kind) {
  const [s, setS] = useState({ results: [], loading: false, error: null });
  useEffect(() => {
    const term = q.trim();
    if (term.length < 2) { setS({ results: [], loading: false, error: null }); return undefined; }
    const ctl = new AbortController();
    setS(p => ({ ...p, loading: true, error: null }));
    const t = setTimeout(() => {
      findMatches(term, kind, ctl.signal)
        .then(d => setS({ results: [...d.results].sort((a, b) => ORDER[a.kind] - ORDER[b.kind]), loading: false, error: null }))
        .catch(e => e.name !== "AbortError" && setS({ results: [], loading: false, error: e.message }));
    }, 220);
    return () => { clearTimeout(t); ctl.abort(); };
  }, [q, kind]);
  return s;
}

// Runs one AI search (streamed) or reopens a saved one.
export function useAiSearch(req) {
  const [s, setS] = useState(IDLE);
  useEffect(() => {
    if (!req || (!req.code && !req.savedId && (req.q || "").trim().length < 2)) { setS(IDLE); return undefined; }
    const ctl = new AbortController();
    let alive = true;
    const set = (fn) => alive && setS(fn);
    setS({ ...IDLE, status: "loading" });
    const run = req.savedId
      ? savedAi(req.savedId).then(d => set({ status: "done", text: d.text, error: null, done: { ...d, cached: true },
          meta: { q: d.q, entity: { kind: d.kind, code: d.code, name: d.name }, name: d.name, matches: [], facts: d.facts, model: "Claude Opus 5.5" } }))
      : streamAi({ q: req.q || req.code, kind: req.kind || "all", code: req.code || null, fresh: !!req.fresh }, {
          signal: ctl.signal,
          onMeta: m => set(p => ({ ...p, meta: m })),
          onToken: t => set(p => ({ ...p, status: "streaming", text: p.text + t })),
          onDone: d => set(p => ({ ...p, status: d.nomatch ? "nomatch" : "done", done: d })),
        });
    run.catch(e => e.name !== "AbortError" && set(p => ({ ...p, status: "error", error: e.message })));
    return () => { alive = false; ctl.abort(); };
  }, [req]);
  return s;
}
